import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { ReceiptModeCreateDto, ReceiptModeUpdateDto } from '@shared/data-access/dto';
import { ReceiptModeModel } from '@shared/data-access/models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReceiptModeApiService {
  static ROOT_POINT = 'finance/receipt-modes';

  constructor(private apiService: ApiService) { }

  create(data: ReceiptModeCreateDto): Observable<ReceiptModeModel> {
    return this.apiService
      .post(ReceiptModeApiService.ROOT_POINT, data)
      .pipe(map(res => ReceiptModeModel.fromJson(res) as ReceiptModeModel));
  }

  get(id: number, option?: IApiOption): Observable<ReceiptModeModel> {
    return this.apiService
      .get(`${ReceiptModeApiService.ROOT_POINT}/${id}`, option)
      .pipe(map(res => ReceiptModeModel.fromJson(res) as ReceiptModeModel));
  }

  update(id: number, data: ReceiptModeUpdateDto): Observable<ReceiptModeModel> {
    return this.apiService
      .patch(`${ReceiptModeApiService.ROOT_POINT}/${id}`, data)
      .pipe(map(res => ReceiptModeModel.fromJson(res) as ReceiptModeModel));
  }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<ReceiptModeModel>> {
    return this.apiService
      .get(ReceiptModeApiService.ROOT_POINT, query, option)
      .pipe(map(data => new PaginationAdapter(ReceiptModeModel, data)));
  }

  getForReceipts(query: Record<string, any>): Observable<ReceiptModeModel[]> {
    return this.apiService
      .get(`${ReceiptModeApiService.ROOT_POINT}/for-receipts`, query)
      .pipe(map(res => ((res as Record<string, unknown>)?.['items'] as unknown[] ?? []).map(item => ReceiptModeModel.fromJson(item) as ReceiptModeModel)));
  }

  getByCode(code: string, option?: IApiOption): Observable<ReceiptModeModel> {
    return this.apiService
      .get(`${ReceiptModeApiService.ROOT_POINT}/by-code/${code}`, option)
      .pipe(map(res => ReceiptModeModel.fromJson(res) as ReceiptModeModel));
  }

  delete(id: number, data = {}, option?: IApiOption): Observable<any> {
    return this.apiService.delete(ReceiptModeApiService.ROOT_POINT + '/' + id, data, option);
  }
}
